// extracted by mini-css-extract-plugin
export default {"multiline":"XM19u6fSJdh9_Ly"};